import { useEffect, useState } from "react";
import { HOUSE } from "@/constants/testIds";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-700 ${
        scrolled
          ? "backdrop-blur-xl bg-[var(--black)]/85 border-b border-[var(--border-dark)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <button
          onClick={() => scrollTo("hero")}
          data-testid={HOUSE.navLogo}
          className="flex flex-col items-start leading-none text-[var(--ivory)] hover:text-[var(--gold-light)] transition-colors"
        >
          <span className="font-serif text-[10px] uppercase tracking-[0.42em] text-[var(--muted-dark)]">
            The House of
          </span>
          <span className="font-serif text-2xl md:text-[26px] tracking-[0.24em] font-light mt-0.5">
            BORSALUX
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-12">
          <button
            data-testid={HOUSE.navDiscover}
            onClick={() => scrollTo("solution")}
            className="font-sans text-[11px] uppercase tracking-[0.32em] text-[var(--muted-dark)] hover:text-[var(--ivory)] transition-colors"
          >
            Abike
          </button>
          <button
            data-testid={HOUSE.navEnvironments}
            onClick={() => scrollTo("environments")}
            className="font-sans text-[11px] uppercase tracking-[0.32em] text-[var(--muted-dark)] hover:text-[var(--ivory)] transition-colors"
          >
            Environments
          </button>
          <button
            data-testid={HOUSE.navFounder}
            onClick={() => scrollTo("founder")}
            className="font-sans text-[11px] uppercase tracking-[0.32em] text-[var(--muted-dark)] hover:text-[var(--ivory)] transition-colors"
          >
            The Founder
          </button>
        </nav>

        <button
          data-testid={HOUSE.navInquiryCta}
          onClick={() => scrollTo("inquiry")}
          className="hidden sm:inline-flex items-center gap-3 border border-[var(--gold)] text-[var(--ivory)] font-sans uppercase tracking-[0.28em] text-[10px] px-6 py-3 hover:bg-[var(--gold)] hover:text-[var(--black)] transition-all duration-500"
        >
          Inquire
        </button>
      </div>
    </header>
  );
};
